// ─────────────────────────────────────────────────────────────────────────────
// Location Emails Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the locationEmails store slice.
// Per-location selectors are factory selectors (mirror selectCanDo pattern in
// core/store/permissions/permissions.selectors.ts).
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationEmailsState } from './location-emails.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectLocationEmails = createFeatureSelector<LocationEmailsState>('locationEmails');

// ── Per-location selectors (factory) ─────────────────────────────────────────

export const selectLocationEmailsErp = (locationId: number) =>
  createSelector(selectLocationEmails, (state) => state.byLocationId[locationId]?.erp ?? []);

export const selectLocationEmailsVolta = (locationId: number) =>
  createSelector(selectLocationEmails, (state) => state.byLocationId[locationId]?.volta ?? []);

export const selectLocationEmailsLoadingFor = (locationId: number) =>
  createSelector(selectLocationEmails, (state) => state.loadingLocationId === locationId);

// ── Company-wide selectors (factory) ─────────────────────────────────────────
// Flat erp/volta lists across every location under a company, fed by the
// LoadCompanyLocationEmails effect; return [] for an unknown customer id.

export const selectLocationEmailsForCompanyErp = (customerId: number) =>
  createSelector(selectLocationEmails, (state) => state.byCustomerId[customerId]?.erp ?? []);

export const selectLocationEmailsForCompanyVolta = (customerId: number) =>
  createSelector(selectLocationEmails, (state) => state.byCustomerId[customerId]?.volta ?? []);

export const selectLocationEmailsLoadingForCompany = (customerId: number) =>
  createSelector(selectLocationEmails, (state) => state.loadingCustomerId === customerId);

// ── Global selectors ─────────────────────────────────────────────────────────

export const selectLocationEmailsLoading = createSelector(selectLocationEmails, (state) => state.loadingLocationId !== null);

export const selectLocationEmailsLoadingLocationId = createSelector(selectLocationEmails, (state) => state.loadingLocationId);

export const selectLocationEmailsLastMutationError = createSelector(selectLocationEmails, (state) => state.lastMutationError);
